import { render, staticRenderFns } from "./VoucherIterator.vue?vue&type=template&id=8f1316f0&"
import script from "./VoucherIterator.vue?vue&type=script&lang=js&"
export * from "./VoucherIterator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports